import { baseUrl } from "../../../config";
import { EventBus } from "../../../eventbus";
import i18n from "../../../functions/i18next";

export default {
  data() {
    return {
      tabs: [
        {
          label: i18n.tc("common.file", 2),
          icon: "file--complex",
          type: "file",
          results: [],
        },
        {
          label: i18n.tc("common.folder", 2),
          icon: "folder",
          type: "folder",
          results: [],
        },
        /* {
          label: "Collections",
          icon: "collection",
          type: "collection",
          results: [],
        },*/
      ],
      selectedTabIndex: 0,
      show: false,
      isLoading: false,
    };
  },
  created() {
    EventBus.$on(`search-tab-change`, (index) => {
      this.selectedTabIndex = index;
    });

    EventBus.$on(`search`, (data) => {
      this.search(data.value);

      this.show = true;
    });

    EventBus.$on(`search-clear`, () => {
      this.show = false;
      this.wipeTabs();
    });
  },
  methods: {
    search(searchValue) {
      this.isLoading = true;

      this.$axios.get(`${baseUrl}/searchv2?q=${searchValue}`).then((r) => {
        //wipe results from others
        this.wipeTabs();

        if (r.data.result) {
          let resultCount = 0;

          Object.keys(r.data.result).forEach((key) => {
            //ordered by space
            const space = r.data.result[key];

            //add name
            space.name = key;

            //sort by tab
            const sortedLists = this.sortResultsInTabs(space.list);

            //push space with new list to tabs
            this.addSpaceToTabs(space, sortedLists);

            //add to count
            resultCount += space.list.length;
          });

          //send number of results
          this.emitNumberOfResults(resultCount);

          //done loading
          this.isLoading = false;

          //emit done event
          EventBus.$emit("search-done", {});
        }
      });
    },
    emitNumberOfResults(resultCount) {
      EventBus.$emit(`search-results-count`, resultCount);
    },

    wipeTabs() {
      this.tabs = this.tabs.map((tab) => {
        return { ...tab, results: [] };
      });
    },

    sortResultsInTabs(list) {
      const results = {};

      //add kets to results
      this.tabs.forEach((tab) => {
        results[tab.type] = [];
      });

      list.forEach((listItem) => {
        results[listItem.extension ? "file" : "folder"].push(listItem);
      });

      return results;
    },
    addSpaceToTabs(space, sortedLists) {
      this.tabs = this.tabs.map((tab) => {
        if (sortedLists[tab.type].length) {
          //has items so add space
          tab.results.push({ ...space, list: sortedLists[tab.type] });
        }

        return tab;
      });
    },
  },
  watch: {
    selectedTabIndex(newIndex) {
      this.selectedTabIndex = newIndex;
    },
    tabs(newTabs) {
      this.tabs = newTabs;
    },
  },
};
